import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const CreatingProfileStyles = styled(OnboardingPage)`
  .progress {
    margin: 20px auto 0;
    text-align: center;
    width: 100%;
    max-width: 270px;
    padding: 0 10px;

    @media screen and (min-width: 576px) {
      margin: 30px auto 0;
      max-width: 400px;
    }

    .player {
      min-height: 200px;
      font-size: 0;
      line-height: 0;

      @media screen and (min-width: 576px) {
        min-height: 304px;
      }
    }

    .status {
      margin: 20px auto;
    }

    ion-progress-bar {
      margin: 0 auto;
      width: 100%;
      --background: rgba(255, 255, 255, 1);
    }

    .number {
      margin: 10px auto 0;
      font-size: 17px;
      font-weight: 500;
      color: rgba(128, 62, 255, 1);
    }
  }
`;
